import styles from '../css/customModal.module.scss';

const CustomModal = ({
  isOpen,
  onClose,
  // eslint-disable-next-line
  onConfirm,
  // eslint-disable-next-line
  onCancel,
  children,
  closeButton,
  className,
  wider,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  onCancel?: () => void;
  children: React.ReactNode;
  closeButton?: boolean;
  className?: string;
  wider?: boolean;
}) => {
  return (
    <div className={`${styles.modalOverlay} ${styles.noScrollBar} ${isOpen ? styles.open : styles.closed}`}>
      <div className={`${styles.modalContent} ${wider ? styles.wider : styles.normal} ${className || ''}`}>
        {closeButton && <img onClick={onClose} src="/assets/images/close-icon.svg" width={30} height={30} className={styles.closeButton} alt="close modal" />}
        {children}
      </div>
    </div>
  );
};

export default CustomModal;
